import React from 'react'
import { Translate, I18n } from "react-redux-i18n"; 
import { Dialog} from "@blueprintjs/core";
import CustomIcon from "../../components/CustomIcon";
import validators from './validators';
import "./CirclePuzzleGift.scss";
import PuzzleAddressForm from './PuzzleAddressForm';
import CircleMeta from './CircleMeta';
class  CirclePuzzleGift extends React.Component {
    state={
        show_modal: false
    }

    showModal=()=>{
        this.setState({show_modal: true});
    }

    closeModal=()=>{
        this.setState({show_modal: false});
    }

    componentDidUpdate(prevProps){
        if(this.props.loading !== prevProps.loading && this.props.loading===false){
            this.closeModal();
        }
    }

    render(){
        const {show_modal} = this.state;
        const {circle} = this.props;
    return (
        <>
        <div className="custom-card circle-gift-card puzzle" onClick={this.showModal} >
            <CustomIcon name="hand-puzzle" className="icon" size="48" />
            <div className="gift-card-copy">
                <h1><Translate value="whitemonday.puzzle_gift.header" /></h1>
                <div className="copy-details"><Translate value="whitemonday.puzzle_gift.subheading" /></div>
            </div>
        </div>

        <Dialog
        title={I18n.t('whitemonday.puzzle_gift.title')}
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        enforceFocus={true}
        isOpen={show_modal}
        onClose={this.closeModal}
        usePortal={true}>
            <div className="dialog-wrapper circle-gift-card-modal">
                <CircleMeta circle={circle} />
                <div className="gift-card-form">
                <PuzzleAddressForm 
                    validators={validators}
                    sendOrder={this.props.sendOrder}
                    loading={this.props.loading}
                />   
                </div>
            </div>
        </Dialog>
        </>
    ) 
    }
}

export default CirclePuzzleGift;